/**
 * Thin admin-side wrapper around the existing /api/v1/contact campaign
 * endpoints. The backend already gates {@code /api/v1/contact/**} on
 * ROLE_ADMIN (see SecurityConfiguration), so these calls are safe for
 * admin pages — we don't need to duplicate the endpoints under
 * {@code /api/v1/admin/dashboard/}.
 *
 * Re-exports the canonical types from {@code features/broadcast} so
 * admin pages don't have to know that the URL prefix is /contact —
 * the type/contract is the same.
 */
import {
  Campaign,
  CampaignAudiencePreview,
  CampaignDraftBody,
  CampaignEngagementBackfillResponse,
  CampaignListResponse,
  CampaignRecipient,
  CampaignRecipientStatusFilter,
  CampaignSource,
  RenderPreviewBody,
  SuppressCampaignRecipientResponse,
  backfillCampaignEngagement as backfillCampaignEngagementBase,
  cancelCampaign as cancelCampaignBase,
  createCampaignDraft as createCampaignDraftBase,
  deleteCampaignDraft as deleteCampaignDraftBase,
  getCampaignDetail as getCampaignDetailBase,
  getCampaignRecipients as getCampaignRecipientsBase,
  launchCampaignDraft as launchCampaignDraftBase,
  listCampaigns as listCampaignsBase,
  pauseCampaign as pauseCampaignBase,
  previewCampaignAudience as previewCampaignAudienceBase,
  previewCampaignDraftAudience as previewCampaignDraftAudienceBase,
  renderEmailPreview as renderEmailPreviewBase,
  resumeCampaign as resumeCampaignBase,
  runCampaignBatchNow as runCampaignBatchNowBase,
  sendTestCampaignEmail as sendTestCampaignEmailBase,
  suppressCampaignRecipient as suppressCampaignRecipientBase,
  updateCampaignDraft as updateCampaignDraftBase,
} from '../../broadcast/api/contactEmailApi';

export type {
  Campaign,
  CampaignAudiencePreview,
  CampaignDraftBody,
  CampaignEngagementBackfillResponse,
  CampaignListResponse,
  CampaignRecipient,
  CampaignRecipientStatusFilter,
  CampaignSource,
  RenderPreviewBody,
  SuppressCampaignRecipientResponse,
};

export const listCampaigns = listCampaignsBase;
export const getCampaignDetail = getCampaignDetailBase;
export const getCampaignRecipients = getCampaignRecipientsBase;
export const backfillCampaignEngagement = backfillCampaignEngagementBase;
export const cancelCampaign = cancelCampaignBase;
export const pauseCampaign = pauseCampaignBase;
export const resumeCampaign = resumeCampaignBase;
export const runCampaignBatchNow = runCampaignBatchNowBase;
export const renderEmailPreview = renderEmailPreviewBase;
export const sendTestCampaignEmail = sendTestCampaignEmailBase;
export const suppressCampaignRecipient = suppressCampaignRecipientBase;
export const createDraft = createCampaignDraftBase;
export const updateDraft = updateCampaignDraftBase;
export const launchDraft = launchCampaignDraftBase;
export const previewDraftAudience = previewCampaignDraftAudienceBase;
export const previewAudience = previewCampaignAudienceBase;
export const deleteDraft = deleteCampaignDraftBase;
